import {Controller} from "stimulus"

export default class extends Controller {
  static targets = ["toggleable", "toggleMenu"]

  toggleDropdown() {
    this.toggleableTarget.classList.toggle('is-active')
  }

}